<template>
  <div id="starnote">
     <div class="article">
        <div class="content">
             <img src="../../static/images/star.svg"  alt="StarNote">
              {{ post.title }} 　
            <p class="posttime">@{{ post.author }} 　{{ post.created | formatTime}} </p>
            <p>摘要：{{ JSON.parse(post.json_metadata).text }}</p>

            <!--显示章节内容-->
            <div>
                <div v-for="(item, ckey) in chapters">
                    <!--子组件显示章节内容-->
                    <StarnoteList :parentmsg="item" :ckey="ckey"></StarnoteList>
                </div>
            </div>
         </div>
     </div>

    <!--加载动画-->
    <transition name="fade">
      <loading v-if="isLoading"></loading>
    </transition>

  </div>
</template>

<script>
  import Loading from './Loading'
  import StarnoteList from './StarnoteList'
    export default {
      name: "Starnote",
      data() {
        return {
            isLoading: false,
            post: {},
            chapters: []
          }
      },
      methods: {

      },

      filters:{
        formatTime(data){
          return data.substring(0,10)
        }
      },

      components: {
        Loading,
        StarnoteList
      },

        mounted() {
            let author = this.$route.params.author
            let permlink = this.$route.params.permlink
            let that = this
            //如果vuex中有值，则直接取出，否则从steem网络中取
            if(this.$store.state.created != false){
                let posts = this.$store.state.created
                posts.forEach(item => {
                    if(item.author === author && item.permlink === permlink){
                        this.post = item
                    }
                })
                async function getChapter() {
                    //从steem上获取本课程所有的结果
                    let res = await that.steem.api.getContentRepliesAsync(author, permlink)
                    let chapterRes = []
                    if (res.length > 0) {
                        res.forEach(item => {
                            if (item.author === author) {
                                //过滤出是本笔记的章节
                                chapterRes.push(item)
                            }
                        })
                        that.chapters = chapterRes
                    }
                }
                getChapter()
            }else{
                //如果刷新
                async function getSteemData() {
                    that.post = await that.steem.api.getContentAsync(author, permlink)
                    let res = await that.steem.api.getContentRepliesAsync(author, permlink)
                    let chapterRes = []
                    if (res.length > 0) {
                        res.forEach(item => {
                            if (item.author === author) {
                                //过滤出是本笔记的章节
                                chapterRes.push(item)
                            }
                        })
                        that.chapters = chapterRes
                    }
                }
                getSteemData()
            }
        },
    }

</script>

<style scoped>
    #starnote{
        width: 80%;
        margin: 0 auto;
    }

  .article{
    margin-top: 1rem;
  }
  .posttime{
    font-size: 0.8rem;
    display: inline;
      margin-left: 0.5rem;
  }
  .content{
      /*background-color: gray;*/
    color: rgba(55,53,58,0.75);
    align: center;
    margin: 1rem auto;
    padding-top: 1rem;
    padding-bottom: 1rem;
    width: 70%;
  }

  a{
    color: rgba(55,53,58,0.75);
  }

  a:hover{
    color: rgba(29,32,136,0.93);
    text-decoration: none;
  }


</style>
